module.exports = __webpack_public_path__ + "img/perspective_matte .31035726.svg";